export const RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT =
	'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';
